import { render, staticRenderFns } from "./TestsTable.vue?vue&type=template&id=2ec59a99&scoped=true&"
import script from "./TestsTable.vue?vue&type=script&lang=js&"
export * from "./TestsTable.vue?vue&type=script&lang=js&"
import style0 from "./TestsTable.vue?vue&type=style&index=0&id=2ec59a99&scoped=true&lang=css&"
import style1 from "./TestsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec59a99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VIcon,VToolbar})
